module.exports = __webpack_public_path__ + "static/img/banner1.8a133d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner1.jpg
// module id = oVEj
// module chunks = 0